export interface IRoomInfo {
  /** Максимальная стоимость **/
  maxPrice: number | null;
  /** Минимальная общая площадь **/
  minArea: number | null;
  /** Минимальная стоимость **/
  minPrice: number | null;
  /** Колличество квартир **/
  offersCount: number | null;
  /** Статус строительства **/
  type: ENewObjectRoomType | null;
  /** Ссылка на выдачу **/
  url: string | null;
}

export enum ENewObjectRoomType {
  /** Койко-место **/
  Bed = 'bed',
  /** Пятикомнатная квартира **/
  FiveRoom = 'fiveRoom',
  /** Четырехкомнатная квартира **/
  FourRoom = 'fourRoom',
  /** Многокомнатная квартира (6 и более комнат) **/
  Large = 'large',
  /** Однокомнатная квартира **/
  OneRoom = 'oneRoom',
  /** Квартира со свободной планировкой **/
  OpenPlan = 'openPlan',
  /** Комната **/
  Room = 'room',
  /** Доля в квартире **/
  Share = 'share',
  /** Студия **/
  Studio = 'studio',
  /** Трехкомнатная квартира **/
  ThreeRoom = 'threeRoom',
  /** Двухкомнатная квартира **/
  TwoRoom = 'twoRoom',
}
